// extracted by mini-css-extract-plugin
export default {"unorderedList":"General_unorderedList__oqhf9","breadcrumbColor":"General_breadcrumbColor__5qwTg","spanMargin":"General_spanMargin__t2OSq"};